<template>
    <div class="stepAreaMain"> 
        <div class="justify-content-center align-items-center stepFormTwo">
            <div class="middleBox mt-0">
                <div class="whiteBG Step-Form "> 
                    <h3 class="mb-4 pb-1 w-100 text-center f-26">{{$t('financial_details')}}</h3>
                    <!--loader - message--->
                    <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                    <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
                    <div class="stepForm">
                        <div class="row mb-2">
                            <div class="col-6">
                                <h3><span class="greenlable">Education Qualification</span> <sup class="red">*</sup></h3>
                            </div>
                            <div class="col-6">
                                <template v-for="(val, key, i) in question_answer_key_array">
                                    <select
                                        v-if="val.question_id == 48"
                                        class="customflaotField form-control"
                                        name="education_qual"
                                        v-model="education_qual"
                                        v-validate="'required'"
                                        :class="{ 'is-invalid': submittedRequest && errors.has('education_qual') }"
                                        @change="()=>ques_ans_array[key.toString()] = education_qual"
                                    >
                                        <option value="" disabled>Education Qualification</option>
                                        <template v-for="ans_list in val.answers">
                                            <option :value="ans_list.ans_id.toString()">{{ ans_list.answer }}</option>
                                        </template>
                                    </select>
                                    <p class="error w-100 mt-2" v-if="submitted && errors.first('education_qual') && val.question_id == 48" >This field is required</p>
                                </template>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">
                                <h3><span class="greenlable">If Employed Please Specify</span> <sup class="red">*</sup></h3>
                            </div>
                            <div class="col-6">
                                <div class="d-flex flex-wrap justify-content-start align-items-center"> 
                                    <select class="customflaotField form-control" v-model="occupation" v-validate="'required'" name="occupation" :class="{ 'is-invalid': submittedRequest && errors.has('occupation') }" :disabled="disable">
                                        <option value="">If Employed Please Specify</option>
                                        <option v-for="(oList,key) in financialDetails.occupation" :class="(occupation == key)?'selected' :''" :value="key">{{$t(oList)}} </option>
                                    </select>
                                    <p class="error w-100 mt-2" v-if="submitted && errors.first('occupation')">This field is required</p>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">
                                <h3><span class="greenlable">{{$t('reg_step_one_point_two')}}</span> <sup class="red">*</sup></h3>
                            </div>
                            <div class="col-6">
                                <div class="d-flex flex-wrap justify-content-start align-items-center"> 
                                    <select class="customflaotField form-control" v-model="yearly_income" v-validate="'required'" name="yearly_income" :class="{ 'is-invalid': submittedRequest && errors.has('yearly_income') }" :disabled="disable">
                                        <option value="">Select Annual Income</option>
                                        <option v-for="(oList,key) in financialDetails.estYearlyIncome" :class="(estYearlyIncome == key)?'selected' :''" :value="key">{{$t(oList)}} </option>
                                    </select>
                                    <p class="error w-100" v-if="submitted && errors.first('yearly_income')">This field is required</p> 
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">
                                <h3><span class="greenlable">{{$t('reg_step_one_point_three')}}</span> <sup class="red">*</sup></h3>
                            </div>
                            <div class="col-6">
                                <div class="d-flex flex-wrap justify-content-start align-items-center"> 
                                    <select class="customflaotField form-control" v-model="net_worth" v-validate="'required'" name="net_worth" :class="{ 'is-invalid': submittedRequest && errors.has('net_worth') }" :disabled="disable">
                                        <option value="">Select Net Worth</option>
                                        <option v-for="(oList,key) in financialDetails.estNetWorth" :class="(estNetWorth == key)?'selected' :''" :value="key">{{$t(oList)}} </option>
                                    </select>
                                    <p class="error w-100" v-if="submitted && errors.first('net_worth')">This field is required</p>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-6">
                                <h3><span class="greenlable">{{$t('reg_step_one_point_four')}}</span> <sup class="red">*</sup></h3>
                            </div>
                            <div class="col-6">
                                <div class="d-flex flex-wrap justify-content-start align-items-center"> 
                                    <select class="customflaotField form-control" v-model="source_of_fund" v-validate="'required'" name="source_of_fund" :class="{ 'is-invalid': submittedRequest && errors.has('source_of_fund') }" :disabled="disable">
                                        <option value="">Select Source Of Funds</option>
                                        <option v-for="(oList,key) in financialDetails.source_of_fund" :class="(source_of_fund == key)?'selected' :''" :value="key">{{$t(oList)}} </option>
                                    </select>
                                    <p class="error w-100" v-if="submitted && errors.first('source_of_fund')">This field is required</p>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-2" v-for="(val, key, i) in question_answer_key_array">
                            <div class="col-12 mb-3" v-if="val.question_id !== 48">
                                <h3 class="text-align-justify"><span class="greenlable">{{val.question}}</span> <sup class="red">*</sup></h3>
                            </div>
                            <div class="col-6" >
                                <template v-if="val.question_id !== 48">
                                    <div class="d-flex align-items-center flex-wrap">
                                        <select
                                            v-if="val.question_id !== 48"
                                            class="customflaotField form-control"
                                            name="question_answer"
                                            v-model="question_answer"
                                            v-validate="'required'"
                                            :class="{ 'is-invalid': submittedRequest && errors.has('question_answer') }"
                                            @change="()=>ques_ans_array[key.toString()] = question_answer"
                                        >
                                            <option value="" disabled>Select</option>
                                            <template v-for="ans_list in val.answers">
                                                <option :value="ans_list.ans_id.toString()">{{ ans_list.answer }}</option>
                                            </template>
                                        </select>
                                        <p class="error w-100" v-if="submitted && errors.first('question_answer')">This field is required</p>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-12">
                                <label class="customRadio-button dot mr-0 f-13">{{$t('step4_readaccept')}}
										<a :href="$env_var.ClientAgreement" target="_blank()">{{$t('ClientAgreement')}} ,</a> 
										<a :href="$env_var.privacyPolicyLinkNew" target="_blank()"> {{$t('step4_privacyplicy')}}</a>, 
										<a :href="$env_var.RefundPolicy" target="_blank()">Refund Policy</a>, 
										<a :href="$env_var.AMLPolicy" target="_blank()">AML Policy</a>, 
										<a :href="$env_var.riskDisclaimer" target="_blank()">{{$t('step4_riskDisclosr')}}</a>,
										<a :href="$env_var.ComplaintsManagement" target="_blank()">Complaints Management Framework</a>,
										<a :href="$env_var.ConflictsManagement" target="_blank()">Conflicts of Interest Manual</a>,
										<a :href="$env_var.PAIAManual" target="_blank()">PAIA Manual</a>,
										{{$t('step4_and')}}
										<a :href="$env_var.UpfrontDisclosure" target="_blank()">Upfront Disclosure</a> 
                                    <sup class="red">*</sup>
                                    <input type="checkbox" class="form-control" v-model="check2" v-validate="'required'" name="check2" :class="{ 'hidden': isHidden }" @change="handleCheckboxChange()" ref="check2Input">
                                    <span class="checkmark"></span>
                                    <!-- <p class="error" v-if="ischeckboxTick && !check2">{{$t('step4_termsAgreeRqd')}}</p> -->
                                    <p class="error" v-if="ischeckboxTick && !check2">{{$t('step4_termsAgreeRqd')}}</p>
                                </label>
                            </div>
                        </div>
                        <div class="row mb-2">
                            <div class="col-12 mobPad">
                                <label class="customRadio-button dot mr-0 f-13">I Agree for my personal data to processed and stored as per privacy policy and for fxview  <sup class="red">*</sup>
                                    <input  type="checkbox" class="form-control" v-model="check4" v-validate="'required'" name="check4" :class="{ 'hidden': isHidden }" ref="check4Input" :disabled="disable" @change="handleCheckboxChange()">
                                    <span class="checkmark"></span>
                                    <p class="error" v-if="ischeckboxTick && !check4">{{$t('step4_termsAgreeRqd')}}</p>
                                    <!-- <p class="error" v-if="submitted" v-for="error in errors.collect('check4')">{{$t('step4_termsAgreeRqd')}}</p> -->
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <div class="full-width pt-4 submitButton align-items-center d-flex spacebetween w-100">
                                    <router-link to="/step1" class="prism_btn stepsBtn backbtn">Back</router-link>
                                    <button class="prism_btn stepsBtn" v-on:click.prevent="submit()">Submit</button>
                                </div>
                            </div>     
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </div>
</template>
<script>
    import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'stepTwo',
        mixins: [fxViewMixins],
        data() {
            return {
                emp_status : '',
                occupation : '',
                yearly_income : '',
                net_worth : '',
				source_of_fund : '',
                step : 2,
                submitted: false,
                response_msg : '',
                userCountry : 'N/A',
                msg_type : '',
                pageLoader : false,
                disable: false,
                submittedRequest: false, 
                type_msg: '',
                check4: false,
                check2: false,
                disable : false,
                ques_ans_array : {},
                education_qual:"",
                question_answer: "",
                terms_agreed: '1',
                question_answer_key_array:[],
                isHidden: true,
                ischeckboxTick: false,
                financialDetails: {},
            }
        },
        methods:{
            handleCheckboxChange() {
                if(!this.check4){}
                if (!this.check2) {} 
                if(this.check4 &&  this.check2) {
                    this.isHidden = !this.isHidden;
                    this.ischeckboxTick = true;
                }
            },
            getValue(key){
                this.ques_ans_array[key.toString()] = this.education_qual
            },
            closeModalFunc(){
                this.$parent.$parent.showStepComponent = false
            },
            ...mapActions({
                _runFinancialDetail: types.RUN_FINANCIAL_DETAILS,
                _runRegisterStepTwo: types.RUN_REGISTER_STEP2,
                _runGetUserIp: types.RUN_GET_USER_IP,
                _runGetQuestionAnswer: types.RUN_GET_QUESTION_ANSWER,
            }),
            submit(){
                this.$trackEvent('CP+Client+Verification+2+Next')
                if(this.disable){
                    let currentStep = this.get_user.step

                    if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
                        currentStep = this.get_user.tempStep
                    }
                    this.get_user.tempStep = currentStep
                    this.get_user.step = '2'         
                    let user_json = this.get_user
                    this.$store.commit(types.SET_STATE, user_json)
                }else{
                    delete this.ques_ans_array[0]
					let ques_ans_array = []
					for(const key in this.ques_ans_array){
						if(this.question_answer_key_array[key]){
							this.question_answer_key_array[key].answers.forEach(val=>{
								if(val.ans_id == this.ques_ans_array[key]){
									let d = {...val}
									d.type = this.question_answer_key_array[key].type
									ques_ans_array.push(d)
								}
							})
						}
					}
                    const _that = this
                    _that.submitted = true;
                    this.ischeckboxTick = true;
                    _that.$validator.validate().then(valid => {
                        if (valid) {
                            let input_json={
                                'globalParams' :{
                                    account_turnover: "0",
                                    occupation : _that.occupation.toString(),
                                    emp_status: "1",
                                    yearly_income : _that.yearly_income.toString(),
                                    net_worth : _that.net_worth.toString(),
                                    source_of_fund : _that.source_of_fund.toString(),
                                    step : _that.step.toString(),
                                    ip_country: this.userCountry,
                                    terms_agreed : _that.terms_agreed.toString(),
									// type_msz_for_spain_user : _that.type_msg,
                                    ques_ans_array: ques_ans_array,
                                },
                                'localParams' :{
                                    "parameter" : _that
                                }
                            }
                            _that._runRegisterStepTwo(input_json)
                        }else{
                            _that.handleValidationErrorAdvanced(_that.errors)
                        }
                    });
                }
            },
            getSelectedLanguage(){
				if(localStorage.getItem('lang')){
					if(localStorage.getItem('lang') == 'Spanish'){
						return 'es';
					}else if(localStorage.getItem('lang') == 'English'){
						return 'en'; 
					}else if(localStorage.getItem('lang') == 'Portuguese'){
						return 'pt'; 
					}
				} else {
					return 'en'; 
				}
			},
        },
        created(){
            // console.log(this._runFinancialDetail({'globalParams' :{},'localParams' :{ "parameter" : this } }), ">>>>step2")
            const _that = this
            this._runFinancialDetail({'globalParams' :{data_type: "financial_question"},'localParams' :{ "parameter" : this } })
            this._runGetUserIp({'globalParams' :{},'localParams' :{ "parameter" : this } })
            _that._runGetQuestionAnswer({
				'globalParams' :{
					question_lang: _that.getSelectedLanguage(),
				},
				'localParams' :{
					"parameter" : _that
				}
			})
            if(parseInt(this.get_user.profile.ipv_status)){
                this.disable = true;
            }
            window.setTimeout(_that._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : _that , "step" : '2'}}), 5000)
            // this._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : this , "step" : '2'}})
        }
    }
</script>
<style>
.hidden {
    display: none;
}
.text-align-justify {
    text-align: justify !important;
}
</style>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step2.vue